import { render, staticRenderFns } from "./MajorsView.vue?vue&type=template&id=c666811e&scoped=true"
import script from "./MajorsView.vue?vue&type=script&lang=js"
export * from "./MajorsView.vue?vue&type=script&lang=js"
import style0 from "./MajorsView.vue?vue&type=style&index=0&id=c666811e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c666811e",
  null
  
)

export default component.exports